import PropTypes from "prop-types";
// project import
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import ProductMark from "@/components/ProductMark";
import { PRODUCT_NAME, PRODUCT_TAGLINE } from "@/config/product";

// ==============================|| DRAWER HEADER ||============================== //

// One layout for both states: the mark and name keep their place, the tagline is only added while
// expanded. It switches with `open` itself — a delayed switch left the expanded header (tagline and
// all) inside the already-narrowed rail while closing, where it overflowed the sidebar edge.
const DrawerHeader = ({ open }) => (
  <DrawerHeaderStyled open={open}>
    <div className="flex items-center gap-2 w-full px-4 h-11 overflow-hidden">
      <ProductMark size={34} className="rounded-lg flex-shrink-0" />
      <div className="min-w-0">
        <h1 className="text-base font-bold text-white tracking-tight leading-tight truncate">{PRODUCT_NAME}</h1>
        {open && <p className="text-xs text-teal-200/80 font-medium truncate">{PRODUCT_TAGLINE}</p>}
      </div>
    </div>
  </DrawerHeaderStyled>
);

DrawerHeader.propTypes = {
  open: PropTypes.bool,
};

export default DrawerHeader;
